import React from 'react';
import './GearLoader.css';

const GearLoader = ({
  text = '',
  className = '',
  ...props
}) => {
  const loaderClasses = [
    'gear-loader',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={loaderClasses} {...props}>
      <div className="gearbox">
        <div className="overlay"></div>
        <div className="gear one">
          <div className="gear-inner">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>
        <div className="gear two">
          <div className="gear-inner">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>
        <div className="gear three">
          <div className="gear-inner">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>
        <div className="gear four large">
          <div className="gear-inner">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>
      </div>
      {text && (
        <div className="gear-loader-text">{text}</div>
      )}
    </div>
  );
};

// Full Page Loading Spinner
export const PageLoader = ({ text = 'Loading...', className = '' }) => (
  <div className={`page-loader ${className}`}>
    <GearLoader text={text} />
  </div>
);

// Inline Loading Spinner
export const InlineLoader = ({ text = '', className = '' }) => (
  <GearLoader text={text} className={`inline-loader ${className}`} />
);

// Button Loading Spinner
export const ButtonLoader = ({ className = '' }) => (
  <div className={`button-loader ${className}`}>
    <GearLoader />
  </div>
);

export default GearLoader;

